import { render, staticRenderFns } from "./desci.vue?vue&type=template&id=6e74c37f"
import script from "./desci.vue?vue&type=script&lang=js"
export * from "./desci.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports